<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title }}</myhead>
  <div class="BGwhite pad12 mb10 flex nowrap start">
    <img :src="reason.thumb" :onerror="imgError" class="radius8 BGf5 height100px width100px mr10" alt="" />
    <div class="flex1 ohide size14">
      <p class="ellipsis size14 weight">{{ reason.name }}</p>
      <p class="C999 mt10 mb10 size10">{{ reason.spec_key_name }}</p>
      <p class="Con">{{ reason.order_msg }}</p>
    </div>
  </div>
  <div class="BGwhite mb10 pad12 flex between">
    <div>
      <p class="a345 size15 weight">退还金额</p>
      <p class="C777 size10">(不超过￥{{ reason.total_amount }}）</p>
    </div>
    <div class="size13 C777 flex">
      <input type="number" style="text-align: right" class="C111 size20 b500 width150px" v-model="money" placeholder="退款金额"
        @change="handleNumberChnage" />
      元
      <img src="@/assets/img/icon36.png" class="height20px ml10" alt="" />
    </div>
  </div>
  <div class="BGwhite mb10 pad12">
    <p class="a345 size15 weight">选择原因</p>
    <van-radio-group v-model="checked">
      <van-radio :name="item.title" class="mt14 size14 weight" v-for="item in reason.return_reason" :key="item.id">{{ item.title }}</van-radio>
      <!-- <van-radio name="1" class="mt14">不喜欢/不想要</van-radio>
      <van-radio name="2" class="mt14">等级选错</van-radio>
      <van-radio name="3" class="mt14">其它</van-radio> -->
    </van-radio-group>
    <div class="mt15 mb20 size13">
      <!-- <span class="Con">
        <router-link :to="{
            path: '/shop/accident/submit',
            query: { id: this.$route.query.id },
          }">事故申诉</router-link>
      </span> -->
      <p class="ml25 C999">如因商品原因导致的{{
        $route.path.includes("cancel") ? "订单取消" : "退货"
      }}，按事故流程处理。
        <br>
        点击下方按钮进行下一步。
      </p>
      <p class="ml25">
        <van-tag @click="$router.push({
          path: '/shop/accident/submit',
          query: { id: this.$route.query.id },
        })" color="#3F7C93" size="medium">事故申诉</van-tag>
      </p>

    </div>
    <p class="b500 size15">原因补充</p>
    <input type="text" class="size13 mt10 mb10 width100" v-model="reasontxt" :placeholder="
        '可补充' +
        ($route.path.includes('cancel') ? '订单取消' : '退货申请') +
        '原因'
      " />
  </div>
  <div class="BGwhite pad12 mb10">
    <p class="b500 size15">描述现状</p>
    <input type="text" class="size13 block width100 mt10 mb10" v-model="describe" placeholder="请如实描述商品现状" />
    <van-uploader :after-read="afterRead" v-model="fileList" multiple />
  </div>
  <p class="center Cred size15 weight" v-if="!$route.path.includes('cancel')">
    建议与卖家协商一致后再申请退货!
  </p>
  <div class="pad50"></div>
  <div class="fixed gray pad10 l r b" v-show="$store.state.nokey">
    <van-button block round type="primary" @click="handleSubmit" :color="btncolor === 0 ? '#3F7C93' : '#999999'">提交</van-button>
  </div>
  <van-popup v-model:show="tipshow" style="width: 100%; border-radius: 5px">
    <div class="tipbox">
      <img src="@/assets/img/icon32.png" class="closeimg" @click="$router.go(-1)" />
      <div class="flex center cen tiptle">
        <img src="@/assets/img/icon60.png" />
        <p class="size18 weight mt10">
          {{ !$route.path.includes("cancel") ? "退货申请风险须知" : "取消订单风险须知" }}
        </p>
      </div>
      <div class="tipcon">
        <template v-if="!$route.path.includes('cancel')">
          <p v-html="info"></p>
          <!-- <p>
            买家在结账前可因自身原因申请退货，为保障买卖双方合理权益，实行以下规则，望悉知！
          </p>
          <p>
            1.买家因自身原因申请退货，卖家将如实提出损失0-208元，如包装费、人工费、配送费等，届时买家需将损失赔付至卖家；
          </p>
          <p>
            2.卖家收到退回商品后验收，如与买家现状描述不符或退回配送中有损坏，卖家有权发起事故向买家索要赔偿。
          </p>
          <p>
            3.若损失赔付违期未支付，将根据《信用**》第*条扣除信用积分并在**公示于众。
          </p> -->
          <button class="size14" @click="handleCloseTip">我已知晓，下一步</button>
        </template>
        <template v-else>
          <p v-html="info"></p>
          <!-- <p>
            买家在结账前可因自身原因取消订单，为保障买卖双方合理权益，实行以下规则，望悉知！
          </p>
          <p>1.下单2小时内极速退款，买家无需赔偿损失；</p>
          <p>
            2.买家因自身原因取消订单，卖家将如实提出损失0-8元，如包装费、人工费、配送费等，届时买家须将损失赔付至卖家；
          </p>
          <p>
            3.若损失赔付违期未支付，将根据《信用**》第*条扣除信用积分并在**公示于众。
          </p> -->
          <button class="size14" @click="handleCloseTip">我已知晓，下一步</button>
        </template>
      </div>
    </div>
  </van-popup>
</template>

<script>
import ajax from "@/utils/request.js";
import { showToast } from "vant";
export default {
  data () {
    return {
      checked: "",
      reason: {},
      money: 0, //退还金额
      reasontxt: "", //退货原因
      describe: "", //商品现状
      file: "",
      fileList: [],
      typeid: 1, //1取消2退货
      tipshow: true, //弹窗
      btncolor: 0,
      info: "",
    };
  },
  watch: {},
  methods: {
    getDetail () { },
    apply () { },
    handleSubmit () {
      this.file = "";
      const that = this;
      const data = {
        id: that.$route.query.id,
        typeid: that.typeid,
        refund_money: that.money,
        return_reason: that.checked,
        reason: that.reasontxt,
        describe: that.describe,

      };
      //批量提交图片
      if (this.fileList.length > 0) {
        that.fileList.forEach((item) => {
          ajax
            .post("api/dyuploadimg", { file: item.file })
            .then((res) => {
              if (that.file === "") {
                that.file = res.data.url;
              } else {
                that.file = that.file + "," + res.data.url;
              }
            }).then(() => {
              data.imgs = that.file;
              ajax.post("order/cancel", data).then((res) => {
                if (res.errcode === 1) {
                  showToast("申请提交成功");
                  this.btncolor = 1;
                  history.go(-1);
                }
              });
            });
        })

      } else {
        data.imgs = that.file;
        ajax.post("order/cancel", data).then((res) => {
          if (res.errcode === 1) {
            showToast("申请提交成功");
            this.btncolor = 1;
            history.go(-1);
          }
        });
      }
    },
    handleCloseTip () {
      this.tipshow = false;
    },
    handleNumberChnage () {
      if (this.money > this.reason.total_amount) {
        this.money = this.reason.total_amount;
      }
    },
  },
  created () {
    this.typeid = this.$route.path.includes("cancel") ? 1 : 2;
    //获取退货通知信息
    ajax
      .post("api/getagreement", { typeid: this.typeid == 1 ? 7 : 6 })
      .then((res) => {
        this.info = res.data.content;
      });
    //获取退货问题等信息
    ajax
      .post("order/getcancel", {
        id: this.$route.query.id,
        typeid: this.typeid,
      })
      .then((res) => {
        this.reason = res.data;
        this.money = res.data.total_amount;
      });
  },
};
</script>

<style scoped lang="scss">
.tiptle {
  img {
    display: block;
    width: 6.4vw;
    margin-right: 2.6667vw;
  }
  p {
    color: #333333;
    letter-spacing: 1px;
  }
}
.tipcon {
  margin-top: 6.4vw;
  p {
    margin-bottom: 5.3333vw;
    line-height: 1.4;
  }
}
.tipbox {
  position: relative;
  padding: 5.3333vw 4vw;
  button {
    width: 74.6667vw;
    height: 9.6vw;
    line-height: 9.6vw;
    text-align: center;
    background: #3f7c93;
    border-radius: 5.6vw;
    color: #ffffff;
    font-size: 14px;
  }
  .closeimg {
    width: 4.2667vw;
    position: absolute;
    top: 4.2667vw;
    right: 4.2667vw;
  }
}
</style>
